var map = {
	"./avengers-endgame-bonus.jpg": 1916,
	"./digger.jpg": 2487,
	"./el-corazon-de-la-bestia.jpg": 4254,
	"./madre-siniestra.jpg": 2605,
	"./resident-evil-noche-cero.jpg": 9746,
	"./tadeo-jones-4.jpg": 4167,
	"./verity.jpg": 3904
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 950;